<!-- eslint-disable quotes -->
<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-container>
    <v-dialog v-model="dialog" persistent width="400">
      <v-card>
        <div class="primary">
          <v-card-title class="text-subtitle-2 justify-center"
            ><v-avatar color="white" size="60">
              <div class="black--text">
                {{ request.agent ? request.agent.code : "N/A" }}
              </div>
            </v-avatar></v-card-title
          >
          <div class="divclass white--text">
            {{ request.agent ? request.agent.name : "N/A" }}
          </div>
          <div class="divclass mt-5">
            <v-chip color="black lighten-4" text-color="white" class="mb-5">
              <v-icon left> call </v-icon>
              {{ request.agent ? request.agent.phone_no : "N/A" }}
            </v-chip>
          </div>
        </div>
        <v-divider />
        <v-col class="name mt-n2">
          <v-chip
            class="ma-2"
            :color="
              request.approved === true
                ? 'green'
                : request.rejectionReason === ''
                ? 'grey'
                : 'error'
            "
          >
            {{
              request.approved === true
                ? "Approved"
                : request.rejectionReason === ""
                ? ""
                : "Rejected"
            }} </v-chip
          >Amount</v-col
        >
        <v-col class="mt-n4 name-text"
          ><div color="primary">{{ request.amount | currency }}</div></v-col
        >

        <v-card-text>
          <v-row>
            <v-col class="name"
              >Account No
              <div class="mt-3">
                {{ request.accountNo ? request.accountNo : "N/A" }}
              </div>
            </v-col>
            <v-col class="name"
              >Payment Method
              <div class="mt-3">
                {{ request.paymentMethod ? request.paymentMethod : "N/A" }}
              </div></v-col
            >
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-row>
            <v-col class="name"
              >Agent Code
              <div class="mt-3">
                {{ request.agentCode ? request.agentCode : "N/A" }}
              </div>
            </v-col>
            <v-col class="name"
              >Description
              <div class="mt-2">
                {{ request.description ? request.description : "N/A" }}
              </div></v-col
            >
          </v-row>
          <v-divider class="mt-3" />
          <v-card class="overflow-y-auto" flat>
            <v-card-title class="mx-auto">Attachments</v-card-title>
            <v-card-text>
              <div
                class="d-inline-flex flex-wrap justify-start"
                v-if="request.base64Attachment"
              >
                <pdf
                  class="mx-1 my-1"
                  style="height: 100px; width: 100px"
                  v-if="isPdf(request.base64Attachment)"
                  :src="`data:application/pdf;base64,${request.base64Attachment}`"
                />
                <v-img
                  v-else
                  lazy-src="../../../../assets/loading.gif"
                  :src="`data:image/png;base64,${request.base64Attachment}`"
                  class="mx-1 my-1"
                  style="height: 100px; width: 100px"
                />
              </div>
              <div v-else>
                <v-btn color="primary" dark block outlined @click="clicked">
                  <v-icon class="mx-3">mdi-image-plus</v-icon>
                  Add/Take Photos
                </v-btn>
              </div>
              <input
                type="file"
                ref="upload"
                class="d-none"
                accept="image/*,application/pdf"
                @change="uploadAttachment()"
              />
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-divider />

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            color="success darken-3"
            @click="approvePettyCashRequest()"
            v-if="request.rejectionReason === '' && request.approved === false"
          >
            <v-icon left> done_outline </v-icon>
            Approve
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="request.rejectionReason === '' && request.approved === false"
            class="mx-3"
            @click="rejectdialog = true"
            color="error"
          >
            <v-icon left> close </v-icon>
            Reject
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="mx-3" v-on:click="setDialog = false" color="error" text>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-dialog v-model="rejectdialog" width="350">
        <v-card>
          <v-card-title class="text-h6 grey lighten-2">
            Add Reason
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form v-model="isValid" ref="rejectForm">
                <v-text-field
                  v-model="formData.rejectionReason"
                  filled
                  required
                  :rules="[rules.common.required]"
                  clearable
                ></v-text-field>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              text
              :disabled="!isValid"
              @click="rejectPettyCashRequest()"
            >
              Finish
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog></v-card
    >
  </v-container>
</template>
<script>
import RepoMethods from '../RepoMethods.js'
import helpers from '@/packages/cetus-base/utilities/helpers/helper.js'
import pdf from 'vue-pdf'
export default {
  name: 'ApproveReq',

  data () {
    return {
      rejectdialog: false,
      fileStatus: 'default',
      formData: {
        rejectionReason: ''
      },
      isValid: true,
      rules: {
        common: {
          required: (v) => !!v || 'Required.'
        }
      }
    }
  },

  components: { pdf },
  props: {
    dialog: Boolean,
    request: Object
  },
  computed: {
    setDialog: {
      get () {
        return this.dialog
      },
      set (val) {
        this.$emit('closeDialog', val)
      }
    },
    userData: function () {
      return this.$store.getters['auth/user']
    },
    isCoordinator: function () {
      return this.userData.agent.is_coordinator === true
    },
    approveReject: function () {
      return (
        this.job.document_status === 'In Progress' ||
        this.job.document_status === 'Submitted'
      )
    },

    headers () {
      return [
        { text: 'Document No', value: 'document_no' },
        { text: 'Description', value: 'description' },
        { text: 'Action', value: 'attachment' }
      ]
    },
    uploadedFile: {
      get () {
        return this.request.base64Attachment
      },
      set (value) {
        // eslint-disable-next-line vue/no-mutating-props
        this.request.base64Attachment = value
        this.$store.dispatch('reposession/updateRepoLine', { ...this.request })
        this.imageDialog = false
      }
    }
  },
  methods: {
    ...RepoMethods,
    approvePettyCashRequest: function () {
      const data = {
        documentNo: this.request.documentNo,
        lineNo: this.request.lineNo
      }
      const params = {
        text: 'Are you sure you want to approve this cash request?',
        onConfirm: () => {
          if (this.request.base64Attachment) {
            this.setDialog = false
            this.$store.dispatch('reposession/approvePettyCash', { ...data })
          } else {
            Event.$emit('ApiWarning', 'Attachment is required for approval')
          }
        }
      }
      this.$confirm.show(params)
    },

    rejectPettyCashRequest: function () {
      if (!this.isValid) {
        this.$refs.rejectForm.validate()
      } else {
        const data = {
          documentNo: this.request.documentNo,
          lineNo: this.request.lineNo,
          rejectionReason: this.formData.rejectionReason,
          rejectedBy: this.userData.agent.code
        }
        this.rejectdialog = false
        this.setDialog = false
        this.$refs.rejectForm.reset()
        this.$store.dispatch('reposession/rejectPettyCash', { ...data })
      }
    },
    getPhotos: function (attachments, type) {
      return this.$store.getters['reposession/getPhotos'](attachments, type)
    },
    getAgent: function () {
      console.log(
        this.$store.getters['reposession/getAgentAuth'](
          this.userData.agent_code
        )
      )
      return this.$store.getters['reposession/getAgentAuth'](
        this.userData.agent_code
      )
    },
    download (item) {
      const a = document.createElement('a')
      a.href = `data:${helpers.detectMimeType(item.base64Attachment)};base64,${
        item.base64Attachment
      }`
      a.download = `${item.profileID}_academics_${
        item.lineNo
      }${helpers.fileExtension(item.base64Attachment)}`
      a.click()
      return this.downloadLink(process.env.VUE_APP_FILE_API + item)
    },
    uploadAttachment: async function () {
      const value = this.$refs.upload.files[0]
      if (value.name !== undefined) {
        if (value.size > 5242880) {
          this.fileStatus = 'error'
        } else {
          this.fileStatus = 'success'
          const file = await helpers.toBase64(value)
          this.uploadedFile = file.split(',')[1]
        }
      } else {
        this.uploadedFile = ''
      }
    },
    clicked () {
      this.$refs.upload.click()
    }
  }
}
</script>

<style scoped>
.name {
  font-size: 13px;
  font-weight: 600;
  font-family: "Overpass", sans-serif;
  color: black;
  text-align: center;
}
.name-text {
  font-size: 30px;
  font-weight: 500;
  text-align: center;
}
.divclass {
  font-size: 16px;
  font-weight: 600;
  font-family: "Overpass", sans-serif;
  color: black;
  text-align: center;
}

.d-none {
  display: none;
}
</style>
